import Modal from './Modal'

interface InsightModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  summary: string
  details: string
  icon?: React.ReactNode
  iconColor?: string
}

export default function InsightModal({
  isOpen,
  onClose,
  title,
  summary,
  details,
  icon,
  iconColor = 'text-indigo-600'
}: InsightModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <Modal.Header onClose={onClose}>
        {icon && <div className={iconColor}>{icon}</div>}
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
      </Modal.Header>
      <Modal.Body className="space-y-6">
        {/* Summary */}
        <div>
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-2">
            Summary
          </h3>
          <p className="text-base text-gray-900 leading-relaxed">
            {summary}
          </p>
        </div>

        {/* Details */}
        <div>
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-2">
            Action Items
          </h3>
          <ul className="list-disc list-outside ml-5 space-y-2 text-gray-700 leading-relaxed">
            {details.split('\n').filter(line => line.trim()).map((item, idx) => (
              <li key={idx}>{item.replace(/^[•\-*]\s*/, '')}</li>
            ))}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium"
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}
